import PropTypes from "prop-types";
import PriceGuaranteeModal from "./PriceGuaranteeModal";

export type PriceGuaranteeModalsErrors = {
  email: string;
  phoneNumber: string;
  priceToMatch: string;
  externalLink: string;
  screenshot: string;
  global?: string;
};

PriceGuaranteeModal.propTypes = {
  email: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  priceToMatch: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  externalLink: PropTypes.string.isRequired,
  screenshotName: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    priceToMatch: PropTypes.string,
    externalLink: PropTypes.string,
    screenshot: PropTypes.string,
    global: PropTypes.string,
  }),
  readOnly: PropTypes.bool,
  submitSuccessMessage: PropTypes.string,
  screenshotAllowedMimeTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onPhoneNumberChange: PropTypes.func.isRequired,
  onPriceToMatchChange: PropTypes.func.isRequired,
  onExternalLinkChange: PropTypes.func.isRequired,
  onScreenshotChange: PropTypes.func.isRequired,
};

export const FormSubmitStatuses = {
  EDITING: "editing",
  INPROGRESS: "in-progress",
  COMPLETE: "complete",
};

export const FormSubmitErrors = {
  DEFAULT:
    "There was an error submitting your request. Please contact customer solutions to continue.",
  VALIDATE:
    "There was an error validating your request. Please contact customer solutions to continue.",
  TRY_AGAIN: "There was an error processing your input. Please try again.",
};

export type PriceMatchResponse = {
  success?: boolean;
  validity?: { recaptcha: string };
};
